import React from 'react';

import { BannerLink } from '@confluence/banners/entry-points/OnboardingWarningBanner.tsx';

import { LEARN_MORE_URL } from '../../constants.ts';

import { useBannerAnalytics } from './useBannerAnalytics.ts';

export function LearnMoreLink({ children }: { children: React.ReactNode }) {
	const { fireLearnMoreEvent } = useBannerAnalytics();

	return (
		<BannerLink onClick={fireLearnMoreEvent} href={LEARN_MORE_URL} target="_blank">
			{children}
		</BannerLink>
	);
}
